<ub-filter-list>
  <span label><ng-container i18n>Show</ng-container>:</span>


  <!-- historyFilter
  <button *ngIf="sort.id !== active" mat-button color="primary" (click)="onSelect(sort)">{{ sort.name }}</button>
  <button *ngIf="sort.id === active" mat-button disabled="true">{{ sort.name }}</button> -->

  <ub-simple-list filters>
    <ub-simple-list-item *ngFor="let filter of filters">
      <button mat-button [color]="filter.isActive ? 'default' : 'accent'" (click)="setHistory(filter.value)"
        [disabled]="filter.isActive">{{ filter.title }}</button>
    </ub-simple-list-item>
  </ub-simple-list>
</ub-filter-list>

<ub-simple-list type="block">
  <ub-simple-list-item *ngFor="let item of filtered">
    <eas-relation-title *ngIf="item.type === 'relation'" [id]="item.id"></eas-relation-title>
    <eas-roles-title *ngIf="item.type === 'user_dependent'" [roles]="[item.id]"></eas-roles-title>


    <ub-simple-list type="block">
      <ub-simple-list-item *ngFor="let rec of item.history">
        <ub-label label="{{ rec.start | date }} - {{ rec.end | date }} -">
          <span text *ngIf="item.type === 'relation'">
            <eas-relation-category-title *ngFor="let cat of rec.value ?? []" [id]="item.id" [category]="cat">
            </eas-relation-category-title>
          </span>

          <span text *ngIf="item.type === 'user_dependent'">
            <eas-user-title *ngFor="let cat of rec.value ?? []" [username]="cat"></eas-user-title>
          </span>
        </ub-label>

      </ub-simple-list-item>
    </ub-simple-list>

  </ub-simple-list-item>
</ub-simple-list>
